/**
 * Help §E13-F03 — the `/help_research` page lead.
 *
 * Same shape as `Welcome.tsx` (the `/help` lead): a navy hero, not a numbered
 * card, carrying the standard `help-section-research-welcome` anchor/testid
 * so the section contract stays uniform.
 */
import { helpSectionElementId } from '../help-sections.js';

const ID = helpSectionElementId('research-welcome');

export function ResearchWelcome(): React.JSX.Element {
  return (
    <section
      id={ID}
      data-testid={ID}
      data-help-section="research-welcome"
      aria-labelledby={`${ID}-heading`}
      tabIndex={-1}
      className="scroll-mt-6 overflow-hidden rounded-lg bg-gradient-to-br from-primary to-primary-hover p-8 outline-none sm:p-10"
    >
      <span className="inline-block rounded-full bg-accent/15 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-accent">
        Research Guide
      </span>
      <h2
        id={`${ID}-heading`}
        className="brand-font mt-4 text-3xl font-bold leading-tight text-white sm:text-4xl"
      >
        Researching companies
      </h2>
      <p className="mt-4 max-w-2xl text-[17px] leading-relaxed text-slate-300">
        This guide covers the Research section end to end — building a list of candidate companies,
        running the AI chain that reads and verifies them, and reviewing and publishing the results.
      </p>
      <p className="mt-5 text-sm text-slate-400">
        Pick a topic from the list on the left, or search it by a word you remember.
      </p>
    </section>
  );
}
